module.exports = __webpack_public_path__ + "static/media/madm.94303db6.png";